<template>
  <div>
    <layout-header title="Registro de Clientes" />
    <ets-page v-if="isAllowed">
      <ets-spinner v-if="isClientsLoading" />
      <ets-table v-if="clients.length > 0 && !isClientsLoading" :columns="columns" :data="clients" class="condensed" :fill="true">
        <template slot="row" slot-scope="client" v-if="isAllowed">
          <td>{{ client.row.name }}</td>
          <td>{{ getClassification(client.row) }}</td>
          <td>{{ client.row.segmentName }}</td>
          <td>{{ getCovered(client.row) }}</td>
          <td>{{ getRiskLevel(client.row) }}</td>
          <td class="number">{{ client.row.beginDate | etsdate }}</td>
        </template>
      </ets-table>
    </ets-page>
    <forbidden v-else />
  </div>
</template>

<script>
import { mapState } from "vuex";
import LayoutHeader from "@/components/Layout/LayoutHeader";
import compliance from "@/logic/api/compliance";
import Forbidden from "@/components/Forbidden";
export default {
  name: "PageClients",
  components: {
    LayoutHeader,
    Forbidden
  },
  data: () => ({
    clients: [],
    isClientsLoading: false
  }),
  computed: {
    ...mapState(["userPermissions"]),
    columns() {
      return [
        { text: "Nombre", key: "name" },
        { text: "Clasificación", key: "classification" },
        { text: "Segmento", key: "segmentName" },
        { text: "Cubierto", key: "covered" },
        { text: "Perfil", key: "riskLevel" },
        { text: "Fecha de Inicio", class: "number", key: "beginDate" }
      ];
    },
    isAllowed() {
      return this.userPermissions && this.userPermissions.login;
    }
  },
  methods: {
    async getClients() {
      this.isClientsLoading = true;
      const response = await compliance.getClients();
      const responseSegments = await compliance.getSegments();

      const clientsInfo = response.data.map(client => {
        const segment = responseSegments.data.find(s => s.segmentId === client.segmentId);
        return { ...client, segmentName: segment ? segment.name : null };
      });
      this.clients = clientsInfo.filter(x => !x.endDate).sort((a, b) => a.name - b.name);
      this.isClientsLoading = false;
    },
    getCurrentProfile(client) {
      return client.profiles.find(x => x.endDate === null);
    },
    getClassification(client) {
      const currentProfile = this.getCurrentProfile(client);
      return currentProfile.classification || "-";
    },
    getRiskLevel(client) {
      const currentProfile = this.getCurrentProfile(client);
      return currentProfile.riskLevel || "-";
    },
    getCovered(client) {
      return client.covered ? "Cubierto" : "No Cubierto";
    }
  },
  created() {
    this.getClients();
  }
};
</script>
